// import { 
//   Box, 
//   Container, 
//   Typography, 
//   Grid, 
//   Card,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Stack,
//   Button,
//   Paper,
//   Avatar,
//   AvatarGroup
// } from '@mui/material';
// import {
//   People as PeopleIcon,
//   AdminPanelSettings as AdminIcon,
//   Edit as EditorIcon,
//   Create as WriterIcon,
//   PhotoCamera as ReporterIcon,
//   Person as MemberIcon,
//   Security as SecurityIcon,
//   Lock as LockIcon,
//   CheckCircle as CheckIcon,
//   Shield as ShieldIcon,
//   Assignment as AssignmentIcon,
//   History as HistoryIcon,
//   Settings as SettingsIcon,
//   VerifiedUser as VerifiedIcon
// } from '@mui/icons-material';
// import { useState } from 'react';

// const UserManagementPage = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);

//   // Roller
//   const userRoles = [
//     {
//       icon: <AdminIcon sx={{ fontSize: 50 }} />,
//       title: "Yöneticiler",
//       subtitle: "Sistem Yöneticisi",
//       description: "Platformun tüm alanlarına tam erişim yetkisi. Kullanıcı yönetimi, sistem ayarları ve tüm modülleri kontrol edebilir",
//       color: "#dc2626",
//       gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)",
//       permissions: [
//         "Tam sistem yetkisi",
//         "Kullanıcı yönetimi",
//         "Sistem ayarları",
//         "Tüm içerik kontrolü",
//         "Raporlama ve analitik"
//       ]
//     },
//     {
//       icon: <EditorIcon sx={{ fontSize: 50 }} />,
//       title: "Editörler",
//       subtitle: "İçerik Editörü",
//       description: "İçerik onaylama, düzenleme ve yayın kontrolü yetkisi. Haber akışını yönetir ve kalite kontrolü sağlar",
//       color: "#1e40af",
//       gradient: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)",
//       permissions: [
//         "İçerik onaylama",
//         "Haber düzenleme",
//         "Yayın kontrolü",
//         "Kategori yönetimi",
//         "Yorum moderasyonu"
//       ]
//     },
//     {
//       icon: <WriterIcon sx={{ fontSize: 50 }} />,
//       title: "Yazarlar",
//       subtitle: "İçerik Üreticisi",
//       description: "Haber ve içerik oluşturma yetkisi. Kendi içeriklerini yönetebilir, ancak yayınlamak için editör onayı gerekir",
//       color: "#059669",
//       gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
//       permissions: [
//         "İçerik oluşturma",
//         "Taslak kaydetme",
//         "Medya yükleme",
//         "Kategori atama",
//         "Kendi içeriklerini düzenleme"
//       ]
//     },
//     {
//       icon: <ReporterIcon sx={{ fontSize: 50 }} />,
//       title: "Muhabirler",
//       subtitle: "Saha Muhabiri",
//       description: "Haber girişi ve fotoğraf yükleme yetkisi. Hızlı haber akışı için özel arayüz ve mobil destek",
//       color: "#7c3aed",
//       gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)",
//       permissions: [
//         "Hızlı haber girişi",
//         "Fotoğraf yükleme",
//         "Mobil erişim",
//         "Anlık bildirim",
//         "Basit içerik düzenleme"
//       ]
//     },
//     {
//       icon: <MemberIcon sx={{ fontSize: 50 }} />,
//       title: "Üyeler",
//       subtitle: "Kayıtlı Kullanıcı",
//       description: "Yorum yapma ve içerik etkileşimi yetkisi. Premium içeriklere abone erişimi ve kişiselleştirilmiş deneyim",
//       color: "#ea580c",
//       gradient: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)",
//       permissions: [
//         "Yorum yapma",
//         "İçerik beğenme",
//         "Favori ekleme",
//         "Profil yönetimi",
//         "Premium içerik erişimi"
//       ]
//     }
//   ];

//   // Yetkilendirme Özellikleri
//   const authorizationFeatures = [
//     {
//       icon: <LockIcon sx={{ fontSize: 45 }} />,
//       title: "Granüler İzin Sistemi",
//       description: "Her kullanıcı ve rol için detaylı izin kontrolü",
//       color: "#1e40af"
//     },
//     {
//       icon: <ShieldIcon sx={{ fontSize: 45 }} />,
//       title: "Modül Bazlı Erişim",
//       description: "Modül seviyesinde erişim kontrolü ve yetkilendirme",
//       color: "#dc2626"
//     },
//     {
//       icon: <HistoryIcon sx={{ fontSize: 45 }} />,
//       title: "Aktivite Logları",
//       description: "Tüm kullanıcı işlemlerinin detaylı kaydı",
//       color: "#059669"
//     },
//     {
//       icon: <SettingsIcon sx={{ fontSize: 45 }} />,
//       title: "Özelleştirilebilir Roller",
//       description: "İhtiyaca göre özel roller oluşturabilme",
//       color: "#7c3aed"
//     },
//     {
//       icon: <SecurityIcon sx={{ fontSize: 45 }} />,
//       title: "Güvenlik Politikaları",
//       description: "Gelişmiş güvenlik kuralları ve politikalar",
//       color: "#ea580c"
//     },
//     {
//       icon: <AssignmentIcon sx={{ fontSize: 45 }} />,
//       title: "İçerik Onay Akışı",
//       description: "Esnek ve özelleştirilebilir onay süreçleri",
//       color: "#0891b2"
//     }
//   ];

//   return (
//     <Box>
//       {/* Hero Section */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: `
//             linear-gradient(
//               135deg,
//               #dc2626 0%,
//               #ef4444 50%,
//               #f97316 100%
//             )
//           `,
//           position: 'relative',
//           overflow: 'hidden',
//           color: 'white',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: `
//               radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
//               radial-gradient(circle at 80% 80%, rgba(255, 255, 255, 0.15) 0%, transparent 50%)
//             `,
//             pointerEvents: 'none'
//           }
//         }}
//       >
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
//             <Box
//               sx={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: 100,
//                 height: 100,
//                 borderRadius: '50%',
//                 background: 'rgba(255, 255, 255, 0.2)',
//                 backdropFilter: 'blur(10px)',
//                 mb: 4,
//                 mx: 'auto'
//               }}
//             >
//               <PeopleIcon sx={{ fontSize: 60, color: 'white' }} />
//             </Box>

//             <Typography
//               variant="overline"
//               sx={{
//                 fontSize: '0.9rem',
//                 fontWeight: 900,
//                 letterSpacing: '0.15em',
//                 color: 'rgba(255,255,255,0.9)',
//                 mb: 2,
//                 display: 'block',
//                 textTransform: 'uppercase'
//               }}
//             >
//               KULLANICI VE YETKİ YÖNETİMİ
//             </Typography>

//             <Typography
//               variant="h1"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '4.5rem' },
//                 fontWeight: 800,
//                 mb: 4,
//                 color: 'white',
//                 fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
//                 lineHeight: 1.1
//               }}
//             >
//               Rol Tabanlı Güvenli Yönetim
//             </Typography>

//             <Typography
//               variant="h5"
//               sx={{
//                 fontSize: { xs: '1.2rem', md: '1.5rem' },
//                 color: 'rgba(255,255,255,0.9)',
//                 maxWidth: 800,
//                 mx: 'auto',
//                 lineHeight: 1.6,
//                 fontWeight: 400,
//                 mb: 6
//               }}
//             >
//               5 farklı kullanıcı rolü, granüler izin sistemi ve gelişmiş güvenlik özellikleri ile 
//               ekibinizi güvenle yönetin
//             </Typography>

//             <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 sx={{
//                   background: 'white',
//                   color: '#dc2626',
//                   px: 5,
//                   py: 2,
//                   fontSize: '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   '&:hover': {
//                     background: '#f8fafc',
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 Rolleri İncele
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 sx={{
//                   borderColor: 'white',
//                   color: 'white',
//                   px: 5,
//                   py: 2,
//                   fontSize: '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   borderWidth: 2,
//                   textTransform: 'none',
//                   '&:hover': {
//                     borderWidth: 2,
//                     background: 'rgba(255, 255, 255, 0.1)',
//                     transform: 'translateY(-2px)'
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 Demo Talep Et
//               </Button>
//             </Stack>
//           </Box>
//         </Container>
//       </Box>

//       {/* Kullanıcı Rolleri */}
//       <Box sx={{ py: { xs: 10, md: 16 }, background: '#f8fafc' }}>
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', mb: 10 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 fontWeight: 800,
//                 mb: 3,
//                 background: 'linear-gradient(135deg, #1e293b 0%, #dc2626 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent'
//               }}
//             >
//               Rol Tabanlı Kullanıcı Sistemi
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#64748b',
//                 maxWidth: 700,
//                 mx: 'auto',
//                 lineHeight: 1.6
//               }}
//             >
//               Her rol için özel yetkiler ve arayüz
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {userRoles.map((role, index) => (
//               <Grid item xs={12} md={6} lg={4} key={index}>
//                 <Paper
//                   elevation={0}
//                   onMouseEnter={() => setHoveredCard(index)}
//                   onMouseLeave={() => setHoveredCard(null)}
//                   sx={{
//                     p: 5,
//                     height: '100%',
//                     background: 'white',
//                     border: '1px solid #e2e8f0',
//                     borderRadius: 4,
//                     cursor: 'pointer',
//                     transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&::before': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       height: 4,
//                       background: role.gradient,
//                       transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
//                       transformOrigin: 'left',
//                       transition: 'transform 0.3s ease'
//                     },
//                     '&:hover': {
//                       transform: 'translateY(-8px)',
//                       boxShadow: `0 20px 40px ${role.color}20`,
//                       borderColor: role.color
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: 80,
//                       height: 80,
//                       borderRadius: 3,
//                       background: `${role.color}15`,
//                       color: role.color,
//                       mb: 3,
//                       transition: 'all 0.4s ease',
//                       transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)'
//                     }}
//                   >
//                     {role.icon}
//                   </Box>

//                   <Typography
//                     variant="h5"
//                     sx={{
//                       fontWeight: 700,
//                       mb: 1,
//                       color: '#1e293b',
//                       fontSize: '1.5rem'
//                     }}
//                   >
//                     {role.title}
//                   </Typography>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 500,
//                       mb: 3,
//                       background: role.gradient,
//                       backgroundClip: 'text',
//                       WebkitBackgroundClip: 'text',
//                       WebkitTextFillColor: 'transparent',
//                       fontSize: '1.1rem'
//                     }}
//                   >
//                     {role.subtitle}
//                   </Typography>

//                   <Typography
//                     variant="body1"
//                     sx={{
//                       color: '#64748b',
//                       lineHeight: 1.7,
//                       mb: 3
//                     }}
//                   >
//                     {role.description}
//                   </Typography>

//                   <List dense>
//                     {role.permissions.map((permission, idx) => (
//                       <ListItem key={idx} sx={{ px: 0, py: 0.5 }}>
//                         <ListItemIcon sx={{ minWidth: 32 }}>
//                           <CheckIcon sx={{ color: role.color, fontSize: 20 }} />
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={permission}
//                           primaryTypographyProps={{
//                             fontSize: '0.95rem',
//                             color: '#475569',
//                             fontWeight: 500
//                           }}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Yetkilendirme Özellikleri */}
//       <Box sx={{ py: { xs: 10, md: 16 }, background: 'white' }}>
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', mb: 10 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 fontWeight: 800,
//                 mb: 3,
//                 background: 'linear-gradient(135deg, #1e40af 0%, #7c3aed 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent'
//               }}
//             >
//               Gelişmiş Yetkilendirme
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#64748b',
//                 maxWidth: 700,
//                 mx: 'auto'
//               }}
//             >
//               Güçlü güvenlik ve kontrol özellikleri
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {authorizationFeatures.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Card
//                   sx={{
//                     p: 4,
//                     height: '100%',
//                     background: `${feature.color}05`,
//                     border: `2px solid ${feature.color}20`,
//                     borderRadius: 3,
//                     textAlign: 'center',
//                     transition: 'all 0.3s ease',
//                     '&:hover': {
//                       background: `${feature.color}10`,
//                       borderColor: feature.color,
//                       transform: 'translateY(-5px)',
//                       boxShadow: `0 10px 30px ${feature.color}30`
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: 70,
//                       height: 70,
//                       borderRadius: 2,
//                       background: `${feature.color}20`,
//                       color: feature.color,
//                       mb: 3
//                     }}
//                   >
//                     {feature.icon}
//                   </Box>
//                   <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b', mb: 2 }}>
//                     {feature.title}
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: '#64748b', lineHeight: 1.6 }}>
//                     {feature.description}
//                   </Typography>
//                 </Card>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* CTA Section */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: 'linear-gradient(135deg, #0f172a 0%, #dc2626 100%)',
//           color: 'white',
//           textAlign: 'center'
//         }}
//       >
//         <Container maxWidth="md">
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//               mb: 4
//             }}
//           >
//             <AvatarGroup max={5} sx={{ '& .MuiAvatar-root': { width: 60, height: 60, border: '3px solid white' } }}>
//               <Avatar sx={{ bgcolor: '#1e40af' }}><AdminIcon /></Avatar>
//               <Avatar sx={{ bgcolor: '#dc2626' }}><EditorIcon /></Avatar>
//               <Avatar sx={{ bgcolor: '#059669' }}><WriterIcon /></Avatar>
//               <Avatar sx={{ bgcolor: '#7c3aed' }}><ReporterIcon /></Avatar>
//               <Avatar sx={{ bgcolor: '#ea580c' }}><MemberIcon /></Avatar>
//             </AvatarGroup>
//           </Box>
//           <Typography
//             variant="h2"
//             sx={{
//               fontSize: { xs: '2.5rem', md: '3.5rem' },
//               fontWeight: 800,
//               mb: 3
//             }}
//           >
//             Ekibinizi Güvenle Yönetin
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{
//               mb: 6,
//               opacity: 0.9,
//               lineHeight: 1.6
//             }}
//           >
//             Rol tabanlı yetkilendirme sistemi ile her kullanıcı sadece yetkisi olanları görsün
//           </Typography>
//           <Button
//             variant="contained"
//             size="large"
//             sx={{
//               background: 'white',
//               color: '#dc2626',
//               px: 6,
//               py: 2.5,
//               fontSize: '1.2rem',
//               fontWeight: 700,
//               borderRadius: 2,
//               textTransform: 'none',
//               '&:hover': {
//                 background: '#f8fafc',
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 10px 30px rgba(255, 255, 255, 0.3)'
//               },
//               transition: 'all 0.3s ease'
//             }}
//           >
//             Başlayın
//           </Button>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default UserManagementPage;



import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  Paper,
  Avatar,
  IconButton,
  Divider,
  LinearProgress,
  AvatarGroup
} from '@mui/material';
import {
  AdminPanelSettings as AdminIcon,
  Edit as EditorIcon,
  Create as WriterIcon,
  CameraAlt as ReporterIcon,
  Person as MemberIcon,
  Security as SecurityIcon,
  Shield as ShieldIcon,
  Lock as LockIcon,
  Key as KeyIcon,
  CheckCircle as CheckIcon,
  Block as BlockIcon,
  Visibility as ViewIcon,
  VisibilityOff as HideIcon,
  ArrowForward as ArrowIcon,
  Group as GroupIcon,
  Assignment as TaskIcon,
  Timeline as TimelineIcon,
  Notifications as NotificationIcon,
  History as HistoryIcon,
  VerifiedUser as VerifiedIcon,
  SupervisorAccount as SupervisorIcon,
  ManageAccounts as ManageIcon,
  AutoAwesome as MagicIcon
} from '@mui/icons-material';

const UserRoleManagementPage = () => {
  const [hoveredRole, setHoveredRole] = useState(null);
  const [hoveredFeature, setHoveredFeature] = useState(null);

  // Kullanıcı Rolleri
  const userRoles = [
    {
      id: 'admin',
      name: 'Yönetici',
      icon: <AdminIcon />,
      color: '#dc2626',
      gradient: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
      description: 'Tüm sistem yetkilerine sahip süper kullanıcı',
      permissions: [
        'Tüm içeriklere erişim',
        'Kullanıcı yönetimi',
        'Sistem ayarları',
        'Tema düzenleme',
        'Raporlama',
        'Yedekleme'
      ],
      count: 5,
      features: ['Sınırsız Yetki', 'Sistem Kontrolü', 'Güvenlik Ayarları']
    },
    {
      id: 'editor',
      name: 'Editör',
      icon: <EditorIcon />,
      color: '#3b82f6',
      gradient: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
      description: 'İçerik onaylama ve düzenleme yetkisi',
      permissions: [
        'İçerik onaylama',
        'Haber düzenleme',
        'Kategori yönetimi',
        'Yorum moderasyonu',
        'Yayın planlama',
        'İstatistik görüntüleme'
      ],
      count: 12,
      features: ['İçerik Onayı', 'Düzenleme', 'Moderasyon']
    },
    {
      id: 'writer',
      name: 'Yazar',
      icon: <WriterIcon />,
      color: '#10b981',
      gradient: 'linear-gradient(135deg, #10b981 0%, #047857 100%)',
      description: 'İçerik oluşturma ve kendi yazılarını düzenleme',
      permissions: [
        'Haber oluşturma',
        'Kendi yazılarını düzenleme',
        'Medya yükleme',
        'Taslak kaydetme',
        'Kategori atama',
        'Etiket ekleme'
      ],
      count: 28,
      features: ['İçerik Oluşturma', 'Medya Yükleme', 'Taslak']
    },
    {
      id: 'reporter',
      name: 'Muhabir',
      icon: <ReporterIcon />,
      color: '#f59e0b',
      gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
      description: 'Haber girişi ve fotoğraf yükleme yetkisi',
      permissions: [
        'Haber girişi',
        'Fotoğraf yükleme',
        'Basit düzenleme',
        'Editöre gönderme',
        'Kendi içeriklerini görme',
        'Bildirim alma'
      ],
      count: 45,
      features: ['Haber Girişi', 'Foto Yükleme', 'Hızlı Giriş']
    },
    {
      id: 'member',
      name: 'Üye',
      icon: <MemberIcon />,
      color: '#8b5cf6',
      gradient: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
      description: 'Yorum yapma ve etkileşim yetkisi',
      permissions: [
        'Yorum yapma',
        'Beğeni',
        'Paylaşma',
        'Profil düzenleme',
        'Bildirim ayarları',
        'Okuma geçmişi'
      ],
      count: 1250,
      features: ['Yorum', 'Etkileşim', 'Profil']
    }
  ];

  // Güvenlik Özellikleri
  const securityFeatures = [
    {
      icon: <SecurityIcon />,
      title: 'Rol Bazlı Erişim',
      description: 'Her kullanıcı rolü için özel yetki tanımlama',
      color: '#3b82f6',
      stats: '5 Farklı Rol'
    },
    {
      icon: <ShieldIcon />,
      title: 'Güvenli Kimlik Doğrulama',
      description: 'JWT token ve şifreli oturum yönetimi',
      color: '#10b981',
      stats: 'Bank-Level'
    },
    {
      icon: <HistoryIcon />,
      title: 'Aktivite Logları',
      description: 'Tüm kullanıcı işlemlerinin detaylı kaydı',
      color: '#f59e0b',
      stats: '7/24 İzleme'
    },
    {
      icon: <LockIcon />,
      title: '2FA Desteği',
      description: 'İki faktörlü kimlik doğrulama altyapısı',
      color: '#8b5cf6',
      stats: 'Ekstra Güvenlik'
    },
    {
      icon: <VerifiedIcon />,
      title: 'İzin Sistemi',
      description: 'Granüler izin kontrolü ve yönetimi',
      color: '#ec4899',
      stats: '50+ İzin Türü'
    },
    {
      icon: <NotificationIcon />,
      title: 'Bildirim Yönetimi',
      description: 'Rol bazlı bildirim ve uyarı sistemi',
      color: '#06b6d4',
      stats: 'Real-time'
    }
  ];

  // İş Akışı
  const workflow = [
    {
      step: '1',
      title: 'Kullanıcı Ekle',
      description: 'Yeni kullanıcı oluşturun ve bilgilerini girin',
      icon: <ManageIcon />,
      color: '#3b82f6'
    },
    {
      step: '2',
      title: 'Rol Ata',
      description: 'Kullanıcıya uygun rolü seçin ve atayın',
      icon: <SupervisorIcon />,
      color: '#10b981'
    },
    {
      step: '3',
      title: 'Yetki Belirle',
      description: 'Özel yetkileri düzenleyin ve kaydedin',
      icon: <KeyIcon />,
      color: '#f59e0b'
    },
    {
      step: '4',
      title: 'Aktif Et',
      description: 'Kullanıcıyı aktif edin ve bilgilendirin',
      icon: <CheckIcon />,
      color: '#8b5cf6'
    }
  ];

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          pt: { xs: 12, md: 16 },
          pb: { xs: 10, md: 20 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Animated Blobs */}
        <Box
          sx={{
            position: 'absolute',
            top: -150,
            right: -150,
            width: 500,
            height: 500,
            background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
            borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 10s ease-in-out infinite'
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            bottom: -100,
            left: -100,
            width: 400,
            height: 400,
            background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
            borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 12s ease-in-out infinite reverse'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Chip
                label="KULLANICI & YETKİ YÖNETİMİ"
                icon={<SecurityIcon sx={{ fontSize: '1rem' }} />}
                sx={{
                  background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.2), rgba(153, 27, 27, 0.2))',
                  color: '#dc2626',
                  border: '1px solid rgba(220, 38, 38, 0.3)',
                  backdropFilter: 'blur(10px)',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  mb: 3,
                  px: 2,
                  py: 2.5
                }}
              />
              
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '2.5rem', md: '4.5rem' },
                  fontWeight: 900,
                  color: 'white',
                  mb: 3,
                  lineHeight: 1.1
                }}
              >
                Güvenli ve{' '}
                <span style={{ 
                  background: 'linear-gradient(135deg, #dc2626 0%, #ff6b35 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                  Esnek Yetkilendirme
                </span>
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: { xs: '1.1rem', md: '1.4rem' },
                  lineHeight: 1.6,
                  mb: 5
                }}
              >
                5 farklı kullanıcı rolü, granüler izin sistemi ve kapsamlı güvenlik 
                özellikleri ile ekibinizi yönetin.
              </Typography>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} mb={5}>
                <Button
                  variant="contained"
                  size="large"
                  endIcon={<ArrowIcon />}
                  sx={{
                    background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
                    color: 'white',
                    px: 5,
                    py: 2.5,
                    fontSize: '1.1rem',
                    fontWeight: 700,
                    borderRadius: '50px',
                    textTransform: 'none',
                    boxShadow: '0 8px 32px rgba(220, 38, 38, 0.4)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #991b1b 0%, #dc2626 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 12px 40px rgba(220, 38, 38, 0.5)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                 İletişime Geç
                </Button>

                <Button
                  variant="outlined"
                  size="large"
                  sx={{
                    borderColor: 'rgba(255,255,255,0.3)',
                    color: 'white',
                    px: 5,
                    py: 2.5,
                    fontSize: '1.1rem',
                    fontWeight: 700,
                    borderRadius: '50px',
                    textTransform: 'none',
                    borderWidth: 2,
                    '&:hover': {
                      borderColor: '#dc2626',
                      color: '#dc2626',
                      background: 'rgba(220, 38, 38, 0.1)',
                      borderWidth: 2
                    }
                  }}
                >
                  Demo İzle
                </Button>
              </Stack>

            </Grid>

            <Grid item xs={12} md={6}>
              {/* User Cards Mockup */}
              <Box
                sx={{
                  position: 'relative',
                  height: 500
                }}
              >
                {/* Card 1 - Admin */}
                <Paper
                  sx={{
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: '85%',
                    p: 3,
                    borderRadius: 4,
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.3)',
                    border: '2px solid #dc2626',
                    animation: 'float 6s ease-in-out infinite',
                    zIndex: 3
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                    <Avatar
                      sx={{
                        width: 60,
                        height: 60,
                        background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)'
                      }}
                    >
                      <AdminIcon sx={{ fontSize: '2rem' }} />
                    </Avatar>
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '1.1rem' }}>
                        Ahmet Yılmaz
                      </Typography>
                      <Chip
                        label="Yönetici"
                        size="small"
                        sx={{
                          background: '#dc2626',
                          color: 'white',
                          fontWeight: 700,
                          fontSize: '0.7rem',
                          height: 22
                        }}
                      />
                    </Box>
                  </Stack>
                  <Stack spacing={1}>
                    {['Tüm Yetkiler', 'Sistem Kontrolü', 'Kullanıcı Yönetimi'].map((perm, idx) => (
                      <Stack key={idx} direction="row" spacing={1} alignItems="center">
                        <CheckIcon sx={{ fontSize: '1rem', color: '#10b981' }} />
                        <Typography sx={{ fontSize: '0.85rem', color: '#495057' }}>
                          {perm}
                        </Typography>
                      </Stack>
                    ))}
                  </Stack>
                </Paper>

                {/* Card 2 - Editor */}
                <Paper
                  sx={{
                    position: 'absolute',
                    top: 120,
                    left: 0,
                    width: '85%',
                    p: 3,
                    borderRadius: 4,
                    background: 'rgba(255,255,255,0.9)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                    border: '2px solid #3b82f6',
                    animation: 'float 6s ease-in-out infinite 1s',
                    zIndex: 2
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center" mb={2}>
                    <Avatar
                      sx={{
                        width: 50,
                        height: 50,
                        background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)'
                      }}
                    >
                      <EditorIcon />
                    </Avatar>
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: '#1a1a2e' }}>
                        Ayşe Demir
                      </Typography>
                      <Chip
                        label="Editör"
                        size="small"
                        sx={{
                          background: '#3b82f6',
                          color: 'white',
                          fontWeight: 700,
                          fontSize: '0.7rem',
                          height: 20
                        }}
                      />
                    </Box>
                  </Stack>
                  <Typography sx={{ fontSize: '0.8rem', color: '#6c757d' }}>
                    İçerik onaylama ve düzenleme yetkisi
                  </Typography>
                </Paper>

                {/* Card 3 - Writer */}
                <Paper
                  sx={{
                    position: 'absolute',
                    bottom: 80,
                    right: 20,
                    width: '75%',
                    p: 2.5,
                    borderRadius: 4,
                    background: 'rgba(255,255,255,0.85)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
                    border: '2px solid #10b981',
                    animation: 'float 6s ease-in-out infinite 2s',
                    zIndex: 1
                  }}
                >
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Avatar
                      sx={{
                        width: 45,
                        height: 45,
                        background: 'linear-gradient(135deg, #10b981 0%, #047857 100%)'
                      }}
                    >
                      <WriterIcon />
                    </Avatar>
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '0.95rem' }}>
                        Mehmet Kaya
                      </Typography>
                      <Chip
                        label="Yazar"
                        size="small"
                        sx={{
                          background: '#10b981',
                          color: 'white',
                          fontWeight: 700,
                          fontSize: '0.65rem',
                          height: 18
                        }}
                      />
                    </Box>
                  </Stack>
                </Paper>

                {/* Decorative Elements */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 40,
                    width: 100,
                    height: 100,
                    border: '3px solid rgba(255,255,255,0.1)',
                    borderRadius: '50%'
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Container>

        {/* Dalga Geçişi */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: '100%',
            overflow: 'hidden',
            lineHeight: 0
          }}
        >
          <svg
            viewBox="0 0 1440 400"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '250px', display: 'block' }}
          >
            <path
              d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,181.3C960,192,1056,192,1152,176C1248,160,1344,128,1392,112L1440,96L1440,400L0,400Z"
              fill="#f8f9fa"
            />
          </svg>
        </Box>
      </Box>

      {/* Kullanıcı Rolleri */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
          pb: { xs: 8, md: 12 }}
        }
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#dc2626',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              KULLANICI ROLLERİ
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: '#1a1a2e',
                mb: 2,
                mt: 2
              }}
            >
              5 Farklı Kullanıcı Rolü
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#6c757d',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Her rol için özel yetkiler ve iş akışı tanımlamaları
            </Typography>
          </Box>

          <Grid container spacing={4}>
            {userRoles.map((role, index) => (
              <Grid item xs={12} sm={6} md={4} key={role.id}>
                <Card
                  onMouseEnter={() => setHoveredRole(index)}
                  onMouseLeave={() => setHoveredRole(null)}
                  sx={{
                    height: '100%',
                    borderRadius: 4,
                    border: '2px solid #e2e8f0',
                    position: 'relative',
                    overflow: 'hidden',
                    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    cursor: 'pointer',
                    '&:hover': {
                      transform: 'translateY(-12px) scale(1.02)',
                      boxShadow: `0 24px 48px ${role.color}30`,
                      borderColor: role.color,
                      '& .role-icon': {
                        transform: 'scale(1.2) rotate(10deg)',
                        background: role.gradient
                      },
                      '& .role-badge': {
                        transform: 'scale(1.1)'
                      }
                    },
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 6,
                      background: role.gradient,
                      transform: hoveredRole === index ? 'scaleX(1)' : 'scaleX(0)',
                      transformOrigin: 'left',
                      transition: 'transform 0.4s ease'
                    }
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    {/* Icon & Badge */}
                    <Stack direction="row" justifyContent="space-between" alignItems="start" mb={3}>
                      <Box
                        className="role-icon"
                        sx={{
                          width: 80,
                          height: 80,
                          borderRadius: 3,
                          background: `${role.color}15`,
                          color: role.color,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '2.5rem',
                          transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                          boxShadow: `0 4px 16px ${role.color}20`
                        }}
                      >
                        {role.icon}
                      </Box>

                      <Chip
                        className="role-badge"
                        label={`${role.count} Kullanıcı`}
                        sx={{
                          background: `${role.color}15`,
                          color: role.color,
                          fontWeight: 700,
                          fontSize: '0.8rem',
                          transition: 'transform 0.3s ease'
                        }}
                      />
                    </Stack>

                    {/* Title */}
                    <Typography
                      variant="h5"
                      sx={{
                        fontWeight: 800,
                        color: '#1a1a2e',
                        mb: 1.5
                      }}
                    >
                      {role.name}
                    </Typography>

                    {/* Description */}
                    <Typography
                      sx={{
                        color: '#6c757d',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                        mb: 3
                      }}
                    >
                      {role.description}
                    </Typography>

                    <Divider sx={{ mb: 3 }} />

                    {/* Permissions */}
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: '#1a1a2e',
                        fontSize: '0.9rem',
                        mb: 2
                      }}
                    >
                      Yetkiler:
                    </Typography>

                    <Stack spacing={1.5} mb={3}>
                      {role.permissions.slice(0, 4).map((perm, idx) => (
                        <Stack key={idx} direction="row" spacing={1.5} alignItems="center">
                          <Box
                            sx={{
                              width: 20,
                              height: 20,
                              borderRadius: '50%',
                              background: role.color,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'white',
                              fontSize: '0.7rem',
                              fontWeight: 700,
                              flexShrink: 0
                            }}
                          >
                            ✓
                          </Box>
                          <Typography
                            sx={{
                              fontSize: '0.85rem',
                              color: '#495057',
                              fontWeight: 500
                            }}
                          >
                            {perm}
                          </Typography>
                        </Stack>
                      ))}
                      {role.permissions.length > 4 && (
                        <Typography
                          sx={{
                            fontSize: '0.8rem',
                            color: role.color,
                            fontWeight: 600,
                            pl: 4.5
                          }}
                        >
                          +{role.permissions.length - 4} daha fazla...
                        </Typography>
                      )}
                    </Stack>

                    {/* Features */}
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                      {role.features.map((feature, idx) => (
                        <Chip
                          key={idx}
                          label={feature}
                          size="small"
                          sx={{
                            background: '#f1f3f5',
                            color: '#495057',
                            fontSize: '0.75rem',
                            height: 24
                          }}
                        />
                      ))}
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Rol Karşılaştırma Tablosu */}
          <Box
            sx={{
              mt: 8,
              p: 4,
              borderRadius: 4,
              background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.05), rgba(59, 130, 246, 0.05))',
              border: '2px dashed #e2e8f0'
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 800,
                color: '#1a1a2e',
                mb: 3,
                textAlign: 'center'
              }}
            >
              Hangi Rol Size Uygun?
            </Typography>

            <Grid container spacing={2}>
              {userRoles.map((role, idx) => (
                <Grid item xs={12} sm={6} md={2.4} key={idx}>
                  <Paper
                    sx={{
                      p: 2,
                      textAlign: 'center',
                      borderRadius: 3,
                      border: '2px solid #e2e8f0',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        borderColor: role.color,
                        transform: 'translateY(-4px)',
                        boxShadow: `0 8px 24px ${role.color}20`
                      }
                    }}
                  >
                    <Box sx={{ fontSize: '2rem', mb: 1 }}>
                      {role.icon}
                    </Box>
                    <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', color: '#1a1a2e', mb: 0.5 }}>
                      {role.name}
                    </Typography>
                    <Typography sx={{ fontSize: '0.75rem', color: '#6c757d' }}>
                      {role.count} kullanıcı
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>

       {/* İş Akışı */}
       <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Grid Pattern */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)',
            backgroundSize: '50px 50px',
            opacity: 0.5
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#dc2626',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              KULLANICI EKLEME SÜRECİ
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 2,
                mt: 2
              }}
            >
              4 Adımda Kullanıcı Yönetimi
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Basit ve güvenli kullanıcı ekleme ve yetkilendirme süreci
            </Typography>
          </Box>

          {/* Timeline */}
          <Box sx={{ position: 'relative', maxWidth: 1000, mx: 'auto' }}>
            {/* Connecting Line */}
            <Box
              sx={{
                position: 'absolute',
                top: 60,
                left: { xs: 30, md: 60 },
                right: { xs: 30, md: 60 },
                height: 4,
                background: 'linear-gradient(90deg, #3b82f6, #10b981, #f59e0b, #8b5cf6)',
                borderRadius: 2,
                display: { xs: 'none', md: 'block' }
              }}
            />

            <Grid container spacing={4}>
              {workflow.map((step, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Box
                    sx={{
                      textAlign: 'center',
                      position: 'relative'
                    }}
                  >
                    {/* Step Circle */}
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'inline-block',
                        mb: 3
                      }}
                    >
                      {/* Outer Ring */}
                      <Box
                        sx={{
                          width: 120,
                          height: 120,
                          borderRadius: '50%',
                          border: `4px solid ${step.color}30`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: `${step.color}10`,
                          position: 'relative',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'scale(1.1)',
                            borderColor: step.color,
                            '& .step-icon': {
                              transform: 'scale(1.2) rotate(10deg)'
                            }
                          }
                        }}
                      >
                        {/* Inner Circle */}
                        <Box
                          className="step-icon"
                          sx={{
                            width: 90,
                            height: 90,
                            borderRadius: '50%',
                            background: step.color,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '2.5rem',
                            boxShadow: `0 8px 24px ${step.color}60`,
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {step.icon}
                        </Box>

                        {/* Number Badge */}
                        <Box
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            background: 'white',
                            border: `3px solid ${step.color}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 800,
                            fontSize: '1.1rem',
                            color: step.color,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                          }}
                        >
                          {step.step}
                        </Box>
                      </Box>
                    </Box>

                    {/* Content */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: 'white',
                        mb: 1.5
                      }}
                    >
                      {step.title}
                    </Typography>

                    <Typography
                      sx={{
                        color: 'rgba(255,255,255,0.7)',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                        px: 2
                      }}
                    >
                      {step.description}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>

      {/* Güvenlik Özellikleri */}
      <Box
        sx={{
          background: 'white',
          py: { xs: 8, md: 12 }
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={6} alignItems="center">
            {/* Sol - Görsel */}
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=600&h=700&fit=crop"
                  alt="Security"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />

                {/* Security Badges */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 20,
                    left: 20,
                    right: 20,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                  }}
                >
                  {[
                    { icon: <SecurityIcon />, label: 'SSL Şifreleme', color: '#10b981' },
                    { icon: <ShieldIcon />, label: '2FA Güvenlik', color: '#3b82f6' }
                  ].map((badge, idx) => (
                    <Box
                      key={idx}
                      sx={{
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: 3,
                        p: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 2,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        animation: `float 4s ease-in-out infinite ${idx}s`
                      }}
                    >
                      <Box
                        sx={{
                          width: 45,
                          height: 45,
                          borderRadius: 2,
                          background: badge.color,
                          color: 'white',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '1.3rem'
                        }}
                      >
                        {badge.icon}
                      </Box>
                      <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '0.95rem' }}>
                        {badge.label}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Box>
            </Grid>

            {/* Sağ - Özellikler */}
            <Grid item xs={12} md={7}>
              <Typography
                variant="overline"
                sx={{
                  color: '#dc2626',
                  fontSize: '0.9rem',
                  fontWeight: 700,
                  letterSpacing: '0.1em'
                }}
              >
                GÜVENLİK ÖZELLİKLERİ
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2.5rem', md: '3rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 3,
                  mt: 2
                }}
              >
                Enterprise Seviye{' '}
                <span style={{ color: '#dc2626' }}>Güvenlik</span>
              </Typography>

              <Typography
                sx={{
                  color: '#6c757d',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 5
                }}
              >
                Kullanıcı verilerini ve sistem güvenliğini en üst düzeyde koruyun. 
                Bank seviyesinde güvenlik standartları.
              </Typography>

              {/* Security Features Grid */}
              <Grid container spacing={3}>
                {securityFeatures.map((feature, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Paper
                      onMouseEnter={() => setHoveredFeature(index)}
                      onMouseLeave={() => setHoveredFeature(null)}
                      sx={{
                        p: 3,
                        borderRadius: 3,
                        border: '2px solid #e2e8f0',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        '&:hover': {
                          borderColor: feature.color,
                          transform: 'translateX(8px)',
                          boxShadow: `0 8px 24px ${feature.color}20`,
                          '& .security-icon': {
                            background: feature.color,
                            color: 'white',
                            transform: 'scale(1.1) rotate(5deg)'
                          }
                        }
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="start">
                        <Box
                          className="security-icon"
                          sx={{
                            width: 55,
                            height: 55,
                            borderRadius: 2,
                            background: `${feature.color}15`,
                            color: feature.color,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.5rem',
                            flexShrink: 0,
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {feature.icon}
                        </Box>

                        <Box sx={{ flex: 1 }}>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              color: '#1a1a2e',
                              fontSize: '1rem',
                              mb: 0.5
                            }}
                          >
                            {feature.title}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: '0.85rem',
                              color: '#6c757d',
                              lineHeight: 1.5,
                              mb: 1.5
                            }}
                          >
                            {feature.description}
                          </Typography>
                          <Chip
                            label={feature.stats}
                            size="small"
                            sx={{
                              background: `${feature.color}15`,
                              color: feature.color,
                              fontWeight: 700,
                              fontSize: '0.75rem',
                              height: 24
                            }}
                          />
                        </Box>
                      </Stack>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>

     

      {/* CTA Section */}
     <Container maxWidth="md">
     <Box
        sx={{
          my: 10,
          background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
          py: { xs: 5, md: 3 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Pattern */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
            backgroundSize: '30px 30px',
            opacity: 0.5
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 3
              }}
            >
              Ekibinizi Güvenle Yönetin
            </Typography>

            <Typography
              variant="h5"
              sx={{
                color: 'rgba(255,255,255,0.95)',
                mb: 5,
                maxWidth: 700,
                mx: 'auto',
                lineHeight: 1.6
              }}
            >
              30 gün ücretsiz deneme ile tüm kullanıcı yönetimi özelliklerini keşfedin
            </Typography>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={3}
              sx={{ justifyContent: 'center', mb: 5 }}
            >
              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'white',
                  color: '#dc2626',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                  '&:hover': {
                    background: '#f8f9fa',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
                  }
                }}
              >
                Ücretsiz Başla
              </Button>

              <Button
                variant="outlined"
                size="large"
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  borderWidth: 2,
                  '&:hover': {
                    background: 'rgba(255,255,255,0.1)',
                    borderColor: 'white',
                    borderWidth: 2
                  }
                }}
              >
                Demo Talep Et
              </Button>
            </Stack>

            {/* Trust Badges */}
            {/* <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={4}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              {[
                '✓ Bank seviyesi güvenlik',
                '✓ GDPR uyumlu',
                '✓ ISO 27001 sertifikalı'
              ].map((text, idx) => (
                <Typography
                  key={idx}
                  sx={{
                    color: 'white',
                    fontSize: '0.95rem',
                    fontWeight: 600
                  }}
                >
                  {text}
                </Typography>
              ))}
            </Stack> */}
          </Box>
        </Container>
      </Box>
     </Container>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes morph {
          0%, 100% {
            border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
          }
          25% {
            border-radius: 60% 40% 50% 50% / 30% 60% 40% 60%;
          }
          50% {
            border-radius: 50% 50% 30% 70% / 50% 30% 70% 40%;
          }
          75% {
            border-radius: 30% 70% 60% 40% / 60% 40% 50% 50%;
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </Box>
  );
};

export default UserRoleManagementPage;